export default __webpack_public_path__ + "static/consistent-header-toast-28c848a4129acedb413b2ac69195dd48.png";